import { ReliabilityOfGeneralExaminationPapersPage } from './ReliabilityOfGeneralExaminationPapersPage';
export default ReliabilityOfGeneralExaminationPapersPage;
